export enum FleetAvailabilityStatus {
  IN_PROGRESS = "In progress",
  CANCELLED = "Cancelled",
  COMPLETED = "Completed",
}

export enum FleetAvailabilityType {
  ACCIDENT = "Accident",
  INSPECTION = "Inspection",
  REPAIR = "Repair",
}
